module.exports = __webpack_public_path__ + "img/bar-chart-square-01.bc853d2b.svg";